import styled from "styled-components";
import CheckIcon from "@mui/icons-material/Check";

const Card = styled.div`
  background: ${(props) => (props.isHighlighted ? "#1e64b4" : "#ffffff")};
  color: ${(props) => (props.isHighlighted ? "#ffffff" : "#000000")};
  border-radius: 16px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  height: "100%";
`;

const Price = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  display: flex;
  align-items: baseline;
  gap: 0.25rem;
  font-family: "Inter", sans-serif;

  span {
    font-size: 1rem;
  }
`;

const Title = styled.h2`
  font-size: 1.75rem;
  font-weight: bold;
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Description = styled.p`
  opacity: 0.8;
  font-size: 0.9rem;
  line-height: 1.5;
  font-family: "Inter", sans-serif;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const Feature = styled.li`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  font-family: "Inter", sans-serif;
`;

const Button = styled.button`
  width: 100%;
  padding: 0.75rem;
  border-radius: 25px;
  border: none;
  background: ${(props) => (props.isHighlighted ? "#ffffff" : "#e8f0fe")};
  color: ${(props) => (props.isHighlighted ? "#1e64b4" : "#1e64b4")};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: auto;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

const PricingCard = (props) => {
  const {
    tier,
    price,
    features,
    description,
    buttonText,
    isHighlighted = false,
  } = props;
  return (
    <Card isHighlighted={isHighlighted}>
      <Price>
        <span
          style={{
            fontSize: "40px",
            color: isHighlighted ? "#FFFFFF" : "#205F9C",
          }}
        >
          ${price}
        </span>{" "}
        <span>/month</span>
      </Price>
      <Title>
        {tier === "free" ? "Free" : tier === "pro" ? "Pro" : "Business"}
      </Title>
      <Description>{description}</Description>
      <FeatureList>
        {features.map((feature, index) => (
          <Feature key={index}>
            <CheckIcon size={16} />
            {feature}
          </Feature>
        ))}
      </FeatureList>
      <Button isHighlighted={isHighlighted}>{buttonText}</Button>
    </Card>
  );
};

export default PricingCard;
